import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, Signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FullSpectacleData } from '@oe-backend/types';
import {
	HeadlineComponent,
	TabGroupComponent,
	TabNavigationComponent,
} from '@zeiss/beyond-online-angular';
import { DegreePipe } from '../../pipes/degree.pipe';
import { PositiveDecimalPipe } from '../../pipes/positive-decimal.pipe';

@Component({
	selector: 'app-rx-vrx-display',
	templateUrl: './rx-vrx-display.component.html',
	imports: [
		TranslocoModule,
		NgTemplateOutlet,
		PositiveDecimalPipe,
		DegreePipe,
		HeadlineComponent,
		TabNavigationComponent,
		TabGroupComponent,
		NgIf,
	],
})
export class RxVrxDisplayComponent {
	@Input({ required: true }) $vrxData!: Signal<FullSpectacleData | null | undefined>;
	@Input() rx: FullSpectacleData | undefined;
	@Input() showVrxData: boolean = true;
}
